module.exports = __webpack_public_path__ + "img/post2.b29234c7.png";